import {
  BotUserId,
  channelCustomTypes,
  ONDEMAND_SCENARIO_VERSION,
} from '@inbox-demo-nx/app-v2-ondemand-constants';
import * as commonConstants from '@inbox-demo-nx/constants';
import { ScenarioData } from '@inbox-demo-nx/types';
import { switchFromMainAppToSupportApp } from '@inbox-demo-nx/utils-web-demo-message-handler';

export const scenario: ScenarioData = {
  key: 'ondemand',
  userProfile: { nickname: 'Alex' },
  defaultLanguage: 'en',
  version: ONDEMAND_SCENARIO_VERSION,
  channels: [
    {
      name: 'Notifications',
      customType: channelCustomTypes.notifications,
      members: [BotUserId.NotificationBot],
      states: {
        initial: {},
        start: {
          messages: [
            {
              sender: BotUserId.NotificationBot,
              skipTyping: true,
              content:
                'Hey Alex! Your order has been placed with Sushi Son. They are preparing your food.',
              data: {
                orderInfo: {
                  price: '$60',
                  product: 'Sushi Son Dinner set-A with coke',
                  paymentMethod: 'Visa 5454',
                  address: '400 1st Ave, San Mateo, CA 94401',
                  imageUrl: require('../../assets/sushi.jpg'),
                  title: 'Order confirmation',
                },
              },
            },
          ],
          onChannelEnter(context) {
            context.transitionState('sushiOnItsWay');
          },
        },
        sushiOnItsWay: {
          messages: [
            {
              sender: BotUserId.NotificationBot,
              skipTyping: true,
              content:
                'Your order from Sushi Son will arrive by 6:30pm. Click to chat with your delivery driver.',
              data: {
                actions: [
                  {
                    label: 'Chat with driver',
                    channelCustomType: channelCustomTypes.delivery,
                  },
                ],
              },
            },
          ],
        },
        orderArrived: {
          messages: [
            {
              sender: BotUserId.NotificationBot,
              skipTyping: true,
              content:
                'Thank you for using SendFood. Kim dropped off your order at the front door.',
            },
          ],
          onChannelEnter(context) {
            context.transitionState('csat');
          },
        },
        csat: {
          messages: [
            {
              sender: BotUserId.NotificationBot,
              skipTyping: true,
              customType: commonConstants.messageCustomTypes.csat5,
              content: 'Let us know how we did with your Sushi Son order.',
              data: { csat: 0 },
            },
          ],
          onCSATSelect(data, context) {
            context.transitionState('end');
          },
        },
        end: {
          messages: [
            {
              sender: BotUserId.NotificationBot,
              skipTyping: true,
              content:
                'Thanks for your feedback. Your satisfaction is really important to us.',
            },
          ],
        },
      },
    },
    {
      name: 'Sushi Son Order #123456789',
      customType: channelCustomTypes.delivery,
      members: [BotUserId.Kim],
      states: {
        initial: {
          suggestedReplies: [
            [
              'Can you confirm that wasabi and soy sauce is included in my order?',
              'kimConfirms',
            ],
          ],
          onChannelEnter(context) {
            context.setAnimatingCircleTarget('suggestedReplies');
          },
          onExit(context) {
            context.setAnimatingCircleTarget('');
          },
        },
        kimConfirms: {
          messages: [{ sender: BotUserId.Kim, content: '👌' }],
          after: { targetState: 'askArrivalTime' },
        },
        askArrivalTime: {
          suggestedReplies: [
            ['Any update on arrival time?', 'kimStuckInTraffic'],
          ],
          onEntry(context) {
            context.setAnimatingCircleTarget('suggestedReplies');
          },
          onExit(context) {
            context.setAnimatingCircleTarget('');
          },
        },
        kimStuckInTraffic: {
          async onEntry(context) {
            await switchFromMainAppToSupportApp({
              context,
              nextState: 'kimOnHerWay',
              fallbackDelay: 1000,
            });
          },
          async onChannelEnter(context) {
            await switchFromMainAppToSupportApp({
              context,
              nextState: 'kimOnHerWay',
              fallbackDelay: 1000,
            });
          },
        },
        kimOnHerWay: {
          messages: [
            {
              sender: BotUserId.Kim,
              content: {
                type: 'audio/x-m4a',
                url: require('../../assets/voicememo.m4a'),
              },
              data: {
                map: {
                  eta: 'ETA 20 minutes',
                  imageUrl: require('../../assets/img-map-eta.png'),
                },
                previewText: 'Map shared',
              },
            },
          ],
          after: { targetState: 'replyToKim', delay: 1000 },
        },
        replyToKim: {
          suggestedReplies: [
            ['Okay. Let me know when you arrive.', 'kimAsksDoor'],
          ],
          onEntry(context) {
            context.setAnimatingCircleTarget('suggestedReplies');
          },
          onExit(context) {
            context.setAnimatingCircleTarget('');
          },
        },
        kimAsksDoor: {
          messages: [
            {
              sender: BotUserId.Kim,
              content: "I'm here! Which door do I use?",
            },
            {
              sender: BotUserId.Kim,
              content: {
                type: 'image/jpeg',
                url: require('../../assets/doors.jpg'),
                imageDimension: { width: 720, height: 480 },
              },
            },
          ],
          onEntry(context) {
            context.setAnimatingCircleTarget('chatInput');
          },
          onExit(context) {
            context.setAnimatingCircleTarget('');
          },
          onUserReply(data, context) {
            context.transitionState('kimReacts');
          },
        },
        kimReacts: {
          async onEntry({ channelUrl, sendApiRequest, transitionState }) {
            const lastMessageId = (
              await sendApiRequest({
                type: 'getGroupChannel',
                data: { channelUrl },
              })
            ).last_message?.message_id;

            if (!lastMessageId) return;

            await sendApiRequest({
              type: 'addReaction',
              data: {
                channelUrl,
                userId: BotUserId.Kim,
                reaction: '+1',
                messageId: lastMessageId,
              },
            });

            transitionState({
              customChannelType: channelCustomTypes.notifications,
              state: 'orderArrived',
            });
            transitionState('end');
          },
        },
        end: {},
      },
    },
  ],
};
